import teeWhite from '../assets/images/shop/t1.webp';
import teeCoal from '../assets/images/shop/t2.webp';
import teeClay from '../assets/images/shop/t3.webp';
import capImage from '../assets/images/shop/cap006.webp';
import sweatImage from '../assets/images/shop/sweat005.webp';
import toteImage from '../assets/images/shop/tote004.webp';

export const PRODUCTS = [
  {
    slug: '001-white',
    code: '001 WHITE',
    name: 'White Tee',
    price: '£24.99',
    image: teeWhite,
    alt: '001 White Tee',
    description: 'A heavyweight studio tee built for everyday wear. Clean front, loud intentions.',
    details: [
      'Heavyweight cotton',
      'Relaxed unisex fit',
      'Screen print front',
      'Small-batch production',
    ],
  },
  {
    slug: '002-coal',
    code: '002 COAL',
    name: 'Coal Tee',
    price: '£24.99',
    image: teeCoal,
    alt: '002 Coal Tee',
    description: 'The same staple tee in a darker tone. Designed to take a beating and still look sharp.',
    details: [
      'Heavyweight cotton',
      'Relaxed unisex fit',
      'Screen print front',
      'Soft hand-feel',
    ],
  },
  {
    slug: '003-clay',
    code: '003 CLAY',
    name: 'Clay Tee',
    price: '£24.99',
    image: teeClay,
    alt: '003 Clay Tee',
    description: 'A warm clay colourway with the same no-nonsense construction. Minimal, but not quiet.',
    details: [
      'Heavyweight cotton',
      'Relaxed unisex fit',
      'Screen print front',
      'Ribbed crew neck',
    ],
  },
  {
    slug: '004-cap',
    code: '004 CAP',
    name: 'Cap',
    price: '£19.99',
    image: capImage,
    alt: '004 Cap',
    description: 'A studio cap with an easy fit and clean profile. For bright days and late nights.',
    details: [
      'Adjustable back strap',
      'Embroidered detail',
      'One size fits most',
      'Durable cotton twill',
    ],
  },
  {
    slug: '005-sweat',
    code: '005 SWEAT',
    name: 'Sweatshirt',
    price: '£39.99',
    image: sweatImage,
    alt: '005 Sweatshirt',
    description: 'A heavyweight sweat with a structured shape. Warm enough to disappear into.',
    details: [
      'Heavyweight fleece',
      'Ribbed cuffs + hem',
      'Relaxed fit',
      'Small-batch run',
    ],
  },
  {
    slug: '006-tote',
    code: '006 TOTE',
    name: 'Tote',
    price: '£19.99',
    image: toteImage,
    alt: '006 Tote',
    description: 'A sturdy tote for laptop days, market days, and everything in between.',
    details: [
      'Heavyweight canvas',
      'Long straps for shoulder carry',
      'Printed graphic',
      'Everyday carry',
    ],
  },
];
